import PrettyPrice from './PrettyPrice';

export default PrettyPrice;
